module.exports = __webpack_public_path__ + "img/cinnamon_cc-min.0134fee7.jpg";